<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input placeholder="请输入课件目录名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加课件目录</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleStatusChange(scope.row)"
                  active-color="#13ce66"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="getZin(scope.row)" type="text" size="small">子目录</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd" :p_id="p_id"></Add>
    <Edit :open_add="open_edit" :courseware_directory_id="courseware_directory_id" v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import AfuncApi from '@/api/afunc.js'
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
      AfuncApi
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        dialogVisible:false,
        courseware_directory_id:0,
        p_id:0,
      };
    },
    created() {
      this.initCoursewareDirectoryId();
      this.getTableList();
    },
    watch: {
      '$route.query': {
        immediate: true, 
        handler() {
          this.initCoursewareDirectoryId(); 
          this.getTableList(); 
        }
      }
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//课件目录标题设置
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.curPage = 1;
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      // 初始化courseware_directory_id：优先从路由参数读取，保证参数同步
      initCoursewareDirectoryId() {
        const routeCoursewareDirectoryId = this.$route.query.p_id || 0;
        this.p_id = Number(routeCoursewareDirectoryId); // 转为数字类型，和后端参数类型一致
      },
      async getTableList() {
        this.loading = true;
        try {
          const response = await AfuncApi.call({
            model: 'courseware_directory',
            action: 'index',
            page: this.curPage,
            list_rows: this.pageSize,
            p_id:this.p_id, // 传递最新的courseware_directory_id给控制器
            search: this.formInline.search // 补充搜索参数，保证搜索功能可用
          })
          if (response.code === 1 && response.data) {
            this.tableData = response.data.list.data || []
            this.totalDataNumber = response.data.list.total;
          } else {
            this.tableData = [];
            this.totalDataNumber = 0;
          }
        } catch (error) {
          console.error('加载目录列表失败:', error)
          this.$message.error('加载目录列表失败')
          this.tableData = [];
          this.totalDataNumber = 0;
        } finally {
          // 无论成功/失败，都关闭loading，避免页面卡死
          this.loading = false;
        }
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      // 修复跳转逻辑：带参数跳转并确保列表刷新
      getZin(row){
        // 防御性校验：避免数据异常导致跳转失败
        if (!row || !row.courseware_directory_id) {
          this.$message.warning('数据异常，无法跳转子目录');
          return;
        }
        // 同步组件内courseware_directory_id
        this.p_id = row.courseware_directory_id;
        // 跳转当前页面并携带参数
        this.$router.push({
          path: '/plus/courseware_directory/index',
          query: {
            p_id: row.courseware_directory_id
          }
        });
        // 兜底触发列表刷新（防止路由监听延迟）
        this.getTableList();
      },
      /*编辑活动*/
      editClick(row) {
        this.courseware_directory_id = row.courseware_directory_id;
        this.open_edit = true
      },
      async handleStatusChange(row) {
        // 防御性校验
        if (!row || !row.courseware_directory_id) {
          this.$message.warning('数据异常，无法修改状态');
          return;
        }
        try {
          const response = await AfuncApi.call({
            model: 'courseware_directory',
            action: 'editStatus',
            courseware_directory_id:row.courseware_directory_id,
            status:row.status
          });
          if (response.code === 1) {
            this.$message.success('状态更新成功');
          } else {
            this.$message.error(response.msg || '状态更新失败');
            row.status = row.status === 1 ? 0 : 1;
          }
        } catch (error) {
          console.log(error,'error')
          this.$message.error('状态更新失败');
          row.status = row.status === 1 ? 0 : 1;
        }
      },
      async deleteClick(row) {
        try {
          await this.$confirm(
            '此操作将永久删除该记录, 是否继续?', 
            '提示', 
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          );

          const response = await AfuncApi.call({
            model: 'courseware_directory',
            action: 'del',
            courseware_directory_id: row.courseware_directory_id 
          });

          if (response.code === 1) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getTableList(); // 刷新列表
          } else {
            this.$message.error(response.msg || '删除失败，请稍后重试');
          }
        } catch (error) {
          if (error !== 'cancel') { 
            console.error('删除目录失败:', error);
            this.$message.error('删除失败，接口请求异常');
          } else {
            this.$message.info('已取消删除'); 
          }
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/courseware_directory/index/index.vue